import { Component } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.sass'],
})
export class CarouselComponent {

  globalKpiEnv = [
    {
      companyType: 'Total',
      header: 'Nye selskaper - Totalt'
    },
    {
      companyType: 'CustomerTypeBureau',
      header: 'Nye selskaper - Byrå'
    },
    {
      companyType: 'CustomerTypeStandard',
      header: 'Nye selskaper - Bank + Regnskap'
    }
  ];

  constructor() {}

}
